import { createContext, useContext } from 'react';
import type { DeviceCache } from './cache';

export const DeviceCacheContext = createContext<DeviceCache | null>(null);

export function useDeviceCache(): DeviceCache {
  const value = useContext(DeviceCacheContext);
  if (!value) throw new Error('DeviceCacheContext missing');
  return value;
}
